import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URI, 
  // baseURL: "https://shiportal2.dtsolution.io/unifierapi",
  withCredentials: true, 
  headers: {
    'Content-Type': 'application/json',
  },
});

export default instance;
